import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth-user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js